import { getPackStatus } from 'src/services/apiRequests/SubscriptionService';
import { SubscriptionApiResponse } from 'src/services/responseTypes/subscriptionApiResponse';
import { XtraApiResponse } from 'src/services/responseTypes/xtraApiResponse';
import { getLatestSubscription, getUsersAge } from 'src/utils/common';
import { DynamicObject } from 'src/utils/commonTypes';
import { MOVIE_LANDING_PAGE_RAILS } from 'src/utils/constants/MovieLandingPageRails';
import {
  APPSFLYER_CONSTANTS,
  MOVIE_SEO_MIXPANEL,
  NavMenuElements,
  PartnerPlatforms,
  UserTypes
} from 'src/utils/constants/stringConstants';
import { DEVICE_WIDTH_CONSTANTS } from 'src/utils/constants/utilConstants';
import {
  getActivePartnerSubscriptions,
  getContentOwner,
  isUserSubscribedToPartnerCheck
} from 'src/utils/contentPartnerHelper';
import { getDeviceWidth } from 'src/utils/getDeviceWidth';
import { MIXPANEL_DEFAULT_VALUES } from 'src/utils/mixpanelTypes';
import {
  MixpanelRailTypes,
  RailsMixpanelPayload
} from 'src/utils/railsMixpanelPayloadTypes';
import { gtm } from '../gtm';

import { mixpanelObject } from '.';
// eslint-disable-next-line import/namespace
import {
  MIXPANEL_ACTIVE_PARTNER_SUBSCRIPTION,
  MIXPANEL_ACTUAL_COST,
  MIXPANEL_AGE,
  MIXPANEL_AGGREGATOR_PARTNER_ID,
  MIXPANEL_AGGREGATOR_PARTNER_NAME,
  MIXPANEL_AGGREGATOR_USER_TYPE,
  MIXPANEL_APPSFLYER_ID,
  MIXPANEL_AUDIO_LANGUAGE,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_CAROUSAL_ID,
  MIXPANEL_CAROUSAL_NAME,
  MIXPANEL_CAROUSAL_SLOT_ID,
  MIXPANEL_CHANNEL_NAME,
  MIXPANEL_CHARACTERS,
  MIXPANEL_CITY,
  MIXPANEL_CONTENT_BILLING_TYPE,
  MIXPANEL_CONTENT_COUNT,
  MIXPANEL_CONTENT_DURATION,
  MIXPANEL_CONTENT_ID,
  MIXPANEL_CONTENT_NAME,
  MIXPANEL_CONTENT_ORIGIAL_LANGUAGE,
  MIXPANEL_CONTENT_OWNER,
  MIXPANEL_CONTENT_SPECIFICATION,
  MIXPANEL_CONTENT_TYPE,
  MIXPANEL_COST,
  MIXPANEL_COUNTRY,
  MIXPANEL_CTA,
  MIXPANEL_CURRENT_SUBSCRIPTION,
  MIXPANEL_DAYS_TO_EXPIRY,
  MIXPANEL_ELEMENT,
  MIXPANEL_EPISODE_NO,
  MIXPANEL_FAILURE_REASON,
  MIXPANEL_FREE_TRIAL_EXPIRY_DATE,
  MIXPANEL_FREE_TRIAL_PACKAGE,
  MIXPANEL_GENDER,
  MIXPANEL_GENRE,
  MIXPANEL_HAS_EDUAURAA,
  MIXPANEL_HORIZONTAL_INDEX,
  MIXPANEL_IS_EMAIL_PRESENT,
  MIXPANEL_IS_MOBILE_PRESENT,
  MIXPANEL_IS_RECOMMENDED,
  MIXPANEL_IS_RENTAL,
  MIXPANEL_LANDING_PAGE_NAME,
  MIXPANEL_LATEST_SUBSCRIPTION_PACK,
  MIXPANEL_LATEST_SUBSCRIPTION_PACK_EXPIRY,
  MIXPANEL_LEARN_MORE_PLEX,
  MIXPANEL_LOAD_TIME,
  MIXPANEL_METHOD,
  MIXPANEL_MODEL_NAME,
  MIXPANEL_MODEL_ORIGIN,
  MIXPANEL_NATIVE,
  MIXPANEL_NEW_APP_LANGUAGE,
  MIXPANEL_NEW_AUTOPLAY_SETTING,
  MIXPANEL_NEW_CONTENT_LANGUAGE,
  MIXPANEL_NEXT_EXPIRING_PACK,
  MIXPANEL_NEXT_PACK_EXPIRY_DATE,
  MIXPANEL_NOT_AVAILABLE,
  MIXPANEL_NOT_SUBSCRIBED,
  MIXPANEL_PACK_DURATION,
  MIXPANEL_PACK_SELECTED,
  MIXPANEL_PAGE_NAME,
  MIXPANEL_PARENT_CONTROL_SETTING,
  MIXPANEL_PARTNER_NAME,
  MIXPANEL_POP_UP_GROUP,
  MIXPANEL_POP_UP_NAME,
  MIXPANEL_POP_UP_TYPE,
  MIXPANEL_PUBLISHING_DATE,
  MIXPANEL_RAIL_CONTENT_LISTING,
  MIXPANEL_RAIL_CONTENT_LISTING_ID,
  MIXPANEL_REGISTRING_COUNTRY,
  MIXPANEL_RENTAL,
  MIXPANEL_RENTAL_PURCHASE_DATE,
  MIXPANEL_RENTAL_PURCHASE_EXPIRY_DATE,
  MIXPANEL_RENTAL_RELEASE_DATE,
  MIXPANEL_SEARCH_LANDING,
  MIXPANEL_SELECT_BY,
  MIXPANEL_SERIES,
  MIXPANEL_SESSION_ID,
  MIXPANEL_SOCIAL_NETWORK,
  MIXPANEL_SOURCE,
  MIXPANEL_STATE,
  MIXPANEL_SUBSCRIBED,
  MIXPANEL_SUBSCRIPTION_STATUS,
  MIXPANEL_SUBTITLE_LANGUAGE,
  MIXPANEL_SUBTITLES,
  MIXPANEL_SUCCESS,
  MIXPANEL_TAB_NAME,
  MIXPANEL_TALAMOOS_MODELNAME,
  MIXPANEL_TALAMOOS_VERTICAL_INDEX,
  MIXPANEL_TOP_CATEGORY,
  MIXPANEL_UNIQUE_ID,
  MIXPANEL_USER_TYPE,
  MIXPANEL_VERTICAL_INDEX
} from './mixpanelConstants';
import {
  ctaEvent,
  loginInitiatedEvent,
  loginResultEvent,
  pageRailImpression,
  popupCTAEvent,
  popupLaunchEvent,
  recommendedRailImpression,
  registerSuperProperty,
  sessionEvent,
  setAlias,
  setPeopleProperty
} from './mixpanelEventsHelper';
import {
  FIRST_PAGE_NAME,
  GUEST_TOKEN,
  PARTNER_NAME,
  SELECTED_PLAN,
  SESSION_ID,
  USER_ID,
  USER_TYPE
} from '../../../utils/constants/localStorageConstants';
import {
  getCookie,
  getLocalStorage,
  getSessionStorage,
  setSessionStorage
} from '../../browserStorageHandler';
import {
  AF_USER_ID,
  COUNTRY,
  PARTNER,
  PLAN_ID
} from '../../constants/cookieConstants';
import { clevertapsubscriptionPropertySetter } from '../clevertap/clevertapHelper';
import { getPageName } from '../pageName';

// partner name setter
export const partnerNameSetter = (mixpanelObject: any) => {
  const partnerName = getSessionStorage(PARTNER_NAME) || getCookie(PARTNER);

  mixpanelObject.setProperty(
    MIXPANEL_PARTNER_NAME,
    partnerName ?? mixpanelObject.getProperty(MIXPANEL_PARTNER_NAME)
  );
};

// Common:- UserType property value change
export const getUserTypeForGlobal = (userType: string) => {
  if (userType === UserTypes.GUEST) {
    userType = 'free';
  } else if (userType === UserTypes.REGISTER) {
    userType = 'registered';
  }
  return userType;
};

export const clearCtaEventsProperty = (mixpanelObject: {
  [key: string]: any;
}) => {
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, MIXPANEL_NOT_AVAILABLE);
  mixpanelObject.setProperty(MIXPANEL_TAB_NAME, MIXPANEL_NOT_AVAILABLE);
  mixpanelObject.setProperty(MIXPANEL_CAROUSAL_NAME, MIXPANEL_NOT_AVAILABLE);
  mixpanelObject.setProperty(MIXPANEL_CAROUSAL_ID, MIXPANEL_NOT_AVAILABLE);
  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_NOT_AVAILABLE);
  mixpanelObject.setProperty(MIXPANEL_VERTICAL_INDEX, MIXPANEL_NOT_AVAILABLE);
  mixpanelObject.setProperty(MIXPANEL_HORIZONTAL_INDEX, MIXPANEL_NOT_AVAILABLE);
  mixpanelObject.setProperty(MIXPANEL_POP_UP_NAME, MIXPANEL_NOT_AVAILABLE);
  mixpanelObject.setProperty(MIXPANEL_POP_UP_TYPE, MIXPANEL_NOT_AVAILABLE);
  mixpanelObject.setProperty(MIXPANEL_POP_UP_GROUP, MIXPANEL_NOT_AVAILABLE);
};

// initial user data super property setter
export const initialDataPropertySetter = async (mixpanelObject: {
  [key: string]: any;
}) => {
  mixpanelObject.setProperty(
    MIXPANEL_UNIQUE_ID,
    await mixpanelObject.getUserToken()
  );
  mixpanelObject.setProperty(MIXPANEL_USER_TYPE, getLocalStorage(USER_TYPE));
  mixpanelObject.setProperty(MIXPANEL_USER_TYPE, getLocalStorage(USER_TYPE));

  mixpanelObject.setProperty(
    MIXPANEL_SESSION_ID,
    getSessionStorage(SESSION_ID)
  );
  mixpanelObject.setProperty(MIXPANEL_CITY, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_STATE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_REGISTRING_COUNTRY, 'N/A');
  mixpanelObject.setProperty([MIXPANEL_DAYS_TO_EXPIRY], 'N/A');
  mixpanelObject.setProperty([MIXPANEL_SUBSCRIPTION_STATUS], 'N/A');

  mixpanelObject.setProperty(
    MIXPANEL_LANDING_PAGE_NAME,
    getSessionStorage(FIRST_PAGE_NAME) || 'N/A'
  );
  // mixpanelObject[ MIXPANEL_LANDING_PAGE_NAME ] = getSessionStorage(FIRST_PAGE_NAME)
  registerSuperProperty();
  setPeopleProperty();
  return null;
};

// user details super property setter
export const userDataPropertySetter = async (
  mixpanelObject: {
    [key: string]: any;
  },
  userData: any
) => {
  mixpanelObject.setProperty(
    MIXPANEL_REGISTRING_COUNTRY,
    userData?.registration_country || 'N/A'
  );
  mixpanelObject.setProperty(
    MIXPANEL_UNIQUE_ID,
    await mixpanelObject.getUserToken()
  );

  mixpanelObject.setProperty(
    MIXPANEL_IS_EMAIL_PRESENT,
    mixpanelObject.isEmailPresentForLoggedIn()
  );
  mixpanelObject.setProperty(
    MIXPANEL_IS_MOBILE_PRESENT,
    mixpanelObject.isMobilePresentForLoggedIn()
  );
  if (userData?.consents?.IsThirdPartyDataSharing) {
    mixpanelObject.setProperty(
      MIXPANEL_GENDER,
      (userData?.gender === 'unknown' ? 'other' : userData?.gender) || 'N/A'
    );
    mixpanelObject.setProperty(
      MIXPANEL_AGE,
      getUsersAge(userData?.birthday) || 'N/A'
    );
  }
  registerSuperProperty();
  setPeopleProperty();
};

export const setGlobalUsersData = (
  mixpanelObject: {
    [key: string]: any;
  },
  userData: any,
  usersLocationData: XtraApiResponse | null | undefined
) => {
  const { city, state } = usersLocationData || {};
  mixpanelObject.setProperty(
    MIXPANEL_CITY,
    city || userData?.location?.city || 'N/A'
  );
  mixpanelObject.setProperty(
    MIXPANEL_STATE,
    state || userData?.location?.state || 'N/A'
  );
  mixpanelObject.setProperty(
    MIXPANEL_REGISTRING_COUNTRY,
    userData?.registration_country || 'N/A'
  );
};

// user settings super property setter
export const settingsPropertySetter = (
  mixpanelObject: {
    [key: string]: any;
  },
  settings: any
) => {
  const parental_control_v2 = extractSettingValue(
    settings,
    'parental_control_v2'
  );
  const parsedParentalControlV2 =
    parental_control_v2 &&
    typeof parental_control_v2 !== 'object' &&
    JSON.parse(parental_control_v2);
  const ageRating =
    (parsedParentalControlV2 && parsedParentalControlV2.age_rating) || 'N/A';
  const contentLanguage = extractSettingValue(
    settings,
    'content_language'
  )?.split(',');
  mixpanelObject.setProperty(
    MIXPANEL_NEW_AUTOPLAY_SETTING,
    extractSettingValue(settings, 'auto_play') || 'false'
  );
  mixpanelObject.setProperty(
    MIXPANEL_NEW_APP_LANGUAGE,
    extractSettingValue(settings, 'display_language') || 'N/A'
  );
  mixpanelObject.setProperty(
    MIXPANEL_NEW_CONTENT_LANGUAGE,
    contentLanguage || 'N/A'
  );
  mixpanelObject.setProperty(
    MIXPANEL_PARENT_CONTROL_SETTING,
    !ageRating ? 'N/A' : ageRating
  );
  mixpanelObject.setProperty(
    MIXPANEL_HAS_EDUAURAA,
    extractSettingValue(settings, 'eduauraaClaimed') || 'false'
  );
  registerSuperProperty();
  setPeopleProperty();
};

const extractSettingValue = (settings: DynamicObject[], item: string) => {
  if (settings && Array.isArray(settings)) {
    return settings?.find((setting: DynamicObject) => setting.key === item)
      ?.value;
  }
  return settings[item];
};

export const initializeMixpanelSessionID = (mixpanelObject: {
  [key: string]: any;
}) => {
  if (!getSessionStorage(SESSION_ID)) {
    const interval = setInterval(() => {
      if (window.performance.timing.domContentLoadedEventEnd !== 0) {
        setSessionStorage(SESSION_ID, new Date().getTime() / 1000);
        mixpanelObject.setProperty(
          MIXPANEL_LOAD_TIME,
          String(
            window.performance.timing.domContentLoadedEventEnd -
              window.performance.timing.navigationStart
          )
        );
        // initialDataPropertySetter(mixpanelObject);
        sessionEvent();
        clearInterval(interval);
      }
    }, 10);
  }
  return null;
};

const getSubscriptionData = (subscriptionData: any) => {
  // sorting all the subscribed packs based on the ascending order of their expiry date
  if (subscriptionData && subscriptionData.length > 0) {
    const sortedExpiryPacks =
      subscriptionData &&
      subscriptionData.sort((item1: any, item2: any) => {
        // sorting in ascending order of the expiry date
        if (
          new Date(item1.subscription_end).toISOString() <
          new Date(item2.subscription_end).toISOString()
        ) {
          return -1;
        }
        if (
          new Date(item1.subscription_end).toISOString() >
          new Date(item2.subscription_end).toISOString()
        ) {
          return 1;
        }
        return 0;
      });

    // filtering the upcoming expirying packs based on the first expirying pack. (same expiry date)
    const filteredNextExpiryingPacks = sortedExpiryPacks.filter(
      (e: any) => e.subscription_end === sortedExpiryPacks[0].subscription_end
    );

    // upcoming expiry date of a pack
    const nextPackExpiryDate = filteredNextExpiryingPacks[0].subscription_end;

    // upcoimg expiry pack details
    const nextExpiringPacks = filteredNextExpiryingPacks.map(
      (item: any) =>
        (item.subscription_plan &&
          `${item.subscription_plan.id}_${item.subscription_plan.original_title}_${item.subscription_plan.subscription_plan_type}`) ||
        'N/A'
    );

    // newly subscribed pack
    const latestSubscriptionPack = getLatestSubscription(
      subscriptionData,
      'subscription_start'
    );

    const latestExpiryPackDuration =
      latestSubscriptionPack.subscription_plan.billing_frequency;

    // free trial package filter from the all packs
    const freeTrialPackage = subscriptionData.filter((e: any) => e.free_trial);

    return {
      nextPackExpiryDate,
      nextExpiringPacks,
      latestSubscriptionPack,
      latestExpiryPackDuration,
      freeTrialPackage: freeTrialPackage[0]
    };
  }
  return {};
};

// app-flyer
export const appsflyerPropertySetter = (
  appsFlyerObj: DynamicObject,
  userData: any,
  location: XtraApiResponse | null | undefined,
  Settings: DynamicObject | null | undefined,
  subscriptionData: SubscriptionApiResponse[] | null,
  mixpanelObject: any
) => {
  let subscriptionDetail: any = {};
  if (subscriptionData && Object.keys(subscriptionData).length > 0) {
    subscriptionDetail = getSubscriptionData(subscriptionData);
  }
  const {
    nextPackExpiryDate = '',
    nextExpiringPacks = '',
    latestSubscriptionPack = '',
    latestExpiryPackDuration = '',
    freeTrialPackage = ''
  } = subscriptionDetail;
  const { city, state, country } = location || {};
  const planObjectStr = getLocalStorage(SELECTED_PLAN);
  const selectPackObj = planObjectStr ? JSON.parse(planObjectStr) : '';
  const selectedPlan = selectPackObj
    ? `${selectPackObj.pack_id}_${selectPackObj.pack}_${selectPackObj.pack_type}`
    : 'N/A';
  appsFlyerObj[APPSFLYER_CONSTANTS.EVENT_TYPE] = APPSFLYER_CONSTANTS.EVENT;
  appsFlyerObj[MIXPANEL_CITY] = city || 'N/A';
  appsFlyerObj[MIXPANEL_STATE] = state || 'N/A';
  appsFlyerObj[MIXPANEL_REGISTRING_COUNTRY] =
    userData?.registration_country || 'N/A';
  appsFlyerObj[MIXPANEL_COUNTRY] = country || 'N/A';
  appsFlyerObj[MIXPANEL_USER_TYPE] = getLocalStorage(USER_TYPE);

  appsFlyerObj[MIXPANEL_HAS_EDUAURAA] = Settings?.eduauraaClaimed || 'N/A';
  appsFlyerObj[MIXPANEL_NEXT_EXPIRING_PACK] = nextExpiringPacks || 'N/A';
  appsFlyerObj[MIXPANEL_NEXT_PACK_EXPIRY_DATE] = nextPackExpiryDate || 'N/A';
  appsFlyerObj[MIXPANEL_PACK_DURATION] = latestExpiryPackDuration || 'N/A';
  appsFlyerObj[MIXPANEL_LATEST_SUBSCRIPTION_PACK] =
    latestSubscriptionPack || 'N/A';
  appsFlyerObj[MIXPANEL_LATEST_SUBSCRIPTION_PACK_EXPIRY] =
    nextPackExpiryDate || 'N/A';
  appsFlyerObj[MIXPANEL_FREE_TRIAL_PACKAGE] = freeTrialPackage || 'N/A';
  appsFlyerObj[MIXPANEL_PACK_SELECTED] =
    nextExpiringPacks || selectedPlan || 'N/A';
  appsFlyerObj[MIXPANEL_CURRENT_SUBSCRIPTION] =
    selectPackObj.current_subscription || 'N/A';
  if (appsFlyerObj.eventName === APPSFLYER_CONSTANTS.AF_PURCHASE) {
    appsFlyerObj[APPSFLYER_CONSTANTS.EVENT_REVENUE] = selectPackObj.price;
    appsFlyerObj[APPSFLYER_CONSTANTS.EVENT_REVENUE_CURRENCY] =
      selectPackObj.currency;
  }
  appsFlyerObj[MIXPANEL_APPSFLYER_ID] = getCookie(AF_USER_ID) || '';
  appsFlyerObj[MIXPANEL_PAGE_NAME] = mixpanelObject[MIXPANEL_PAGE_NAME];
  appsFlyerObj[MIXPANEL_SOURCE] = mixpanelObject[MIXPANEL_SOURCE];

  if (userData?.consents?.IsThirdPartyDataSharing) {
    const age =
      new Date().getFullYear() - new Date(userData?.birthday).getFullYear();
    appsFlyerObj[MIXPANEL_AGE] = age.toString() || 'N/A';
    appsFlyerObj[MIXPANEL_GENDER] = userData?.gender || 'N/A';
    appsFlyerObj[MIXPANEL_UNIQUE_ID] =
      getLocalStorage(USER_ID) || getLocalStorage(GUEST_TOKEN) || '';
  }
  return appsFlyerObj;
};

// setting the subscription super property of user
export const subscriptionPropertySetter = (
  mixpanelObject: any,
  subscriptionData: SubscriptionApiResponse[] | null
) => {
  if (subscriptionData?.length) {
    const {
      nextPackExpiryDate,
      nextExpiringPacks,
      latestSubscriptionPack,
      latestExpiryPackDuration,
      freeTrialPackage
    } = getSubscriptionData(subscriptionData);
    mixpanelObject.setProperty(
      MIXPANEL_NEXT_EXPIRING_PACK,
      nextExpiringPacks || 'N/A'
    );
    mixpanelObject.setProperty(
      MIXPANEL_NEXT_PACK_EXPIRY_DATE,
      nextPackExpiryDate || 'N/A'
    );
    mixpanelObject.setProperty(
      MIXPANEL_FREE_TRIAL_EXPIRY_DATE,
      freeTrialPackage ? freeTrialPackage.subscription_end || 'N/A' : 'N/A'
    );
    mixpanelObject.setProperty(
      MIXPANEL_PACK_DURATION,
      latestExpiryPackDuration || 'N/A'
    );
    mixpanelObject.setProperty(
      MIXPANEL_FREE_TRIAL_PACKAGE,
      (freeTrialPackage &&
        latestSubscriptionPack.subscription_plan &&
        `${freeTrialPackage.subscription_plan.id}_${freeTrialPackage.subscription_plan.original_title}_${freeTrialPackage.subscription_plan.subscription_plan_type}`) ||
        'N/A'
    );
    mixpanelObject.setProperty(
      MIXPANEL_LATEST_SUBSCRIPTION_PACK,
      (latestSubscriptionPack &&
        latestSubscriptionPack.subscription_plan &&
        `${latestSubscriptionPack.subscription_plan.id}_${latestSubscriptionPack.subscription_plan.original_title}_${latestSubscriptionPack.subscription_plan.subscription_plan_type}`) ||
        'N/A'
    );
    mixpanelObject.setProperty(
      MIXPANEL_LATEST_SUBSCRIPTION_PACK_EXPIRY,
      latestSubscriptionPack.subscription_end || 'N/A'
    );
    // Difference between current date and latest subscription pack expiry date
    const diffInMilliSeconds =
      (new Date(latestSubscriptionPack.subscription_end) as any) -
      (new Date() as any);

    const diffInDays = Math.floor(diffInMilliSeconds / (1000 * 60 * 60 * 24));

    mixpanelObject.setProperty(MIXPANEL_DAYS_TO_EXPIRY, diffInDays || 'N/A');
    mixpanelObject.setProperty(
      MIXPANEL_SUBSCRIPTION_STATUS,
      getPackStatus(latestSubscriptionPack.subscription_end)
    );

    const planId = mixpanelObject.getProperty(
      MIXPANEL_LATEST_SUBSCRIPTION_PACK
    );
    setSessionStorage(PLAN_ID, planId);
    registerSuperProperty();
    setPeopleProperty();
    clevertapsubscriptionPropertySetter(mixpanelObject);
  }
};

export const setLoginInitiatedAndReturnMixPanel = (
  eventName: string,
  mixpanelObject: any,
  method: string,
  type?: string,
  success?: boolean,
  errorMessage?: string,
  userId?: string
) => {
  mixpanelObject.setProperty(MIXPANEL_METHOD, method);
  mixpanelObject.setProperty(MIXPANEL_SOCIAL_NETWORK, type || 'N/A');
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, 'Sign In');
  mixpanelObject.setProperty(MIXPANEL_SELECT_BY, 'N/A');
  if (eventName === 'initiate') {
    loginInitiatedEvent();
  } else {
    if (success) {
      mixpanelObject.setProperty(MIXPANEL_SUCCESS, true);
      mixpanelObject.setProperty(MIXPANEL_FAILURE_REASON, 'N/A');
      if (userId !== undefined) {
        setAlias(userId, getLocalStorage(GUEST_TOKEN));
      }
      // const propertiesObject = Object.fromEntries(mixpanelObject?.properties);
      // gtm.SubscriptionEventGA4('registration_success', propertiesObject);
    } else {
      mixpanelObject.setProperty(MIXPANEL_SUCCESS, false);
      mixpanelObject.setProperty(MIXPANEL_FAILURE_REASON, errorMessage);
      if (getCookie(COUNTRY) !== 'IN') {
        gtm.SubscriptionEventGA4('registration_failure', mixpanelObject);
      }
    }
    loginResultEvent();
  }
};

export const removeProperties = (
  trackObject: DynamicObject,
  array: Array<string>
) => {
  array.forEach((item: string) => delete trackObject[item]);
};

export const railsPropertySetter = (
  railsMixpanelPayload: RailsMixpanelPayload,
  isSearchLanding = false
) => {
  const {
    trayDetails,
    trayData,
    activeSubscriptions: currentActiveSubscriptions
  } = railsMixpanelPayload;

  const deviceWidth = getDeviceWidth() as number;
  const pageName =
    typeof window !== 'undefined' &&
    window.location &&
    getPageName(window.location.pathname);
  mixpanelObject[MIXPANEL_PAGE_NAME] = trayDetails?.pageName || pageName;
  mixpanelObject[MIXPANEL_LANDING_PAGE_NAME] = trayDetails?.pageName;
  mixpanelObject[MIXPANEL_UNIQUE_ID] = getLocalStorage(GUEST_TOKEN);
  if (trayDetails.type === MixpanelRailTypes.RECO) {
    mixpanelObject[MIXPANEL_CAROUSAL_NAME] = trayDetails.carouselTitle;
    mixpanelObject[MIXPANEL_CAROUSAL_ID] =
      trayDetails?.assestDetails?.contentId;
    mixpanelObject[MIXPANEL_TALAMOOS_MODELNAME] = trayDetails.talamoosModelName;
    mixpanelObject[MIXPANEL_TALAMOOS_VERTICAL_INDEX] =
      trayDetails.isRecommendedColumn &&
      deviceWidth > DEVICE_WIDTH_CONSTANTS.deviceWidth1200
        ? MIXPANEL_DEFAULT_VALUES.NOT_AVAILABLE
        : trayDetails.index;
    // recommendedRailImpression();
    if (!trayDetails.isEpisodeConsumption) {
      if (!trayDetails.pendingDataAvailable) {
        // trigger for landing pages
        recommendedRailImpression();
        return;
      } else if (deviceWidth >= 1200) {
        // trigger for desktop as it dosent wait for column
        recommendedRailImpression();
        return;
      } else if (trayDetails.isPendingResolved) {
        // trigger for devices
        recommendedRailImpression();
        return;
      }
    }
  }
  let railElements: any = MIXPANEL_DEFAULT_VALUES.NOT_AVAILABLE;
  if (trayDetails && trayData?.content?.length) {
    railElements = Array.from(trayData.content)
      .map((s) => s.title)
      .join(',');
    if (
      trayDetails.title === MOVIE_SEO_MIXPANEL.BROWSE_BY_LANGUAGE ||
      trayDetails.title === MOVIE_SEO_MIXPANEL.BROWSE_OF_LANGUAGE ||
      trayDetails.title === MOVIE_SEO_MIXPANEL.BROWSE_OF_GENRE ||
      trayDetails.title === MOVIE_SEO_MIXPANEL.BROWSE_BY_GENRE ||
      trayDetails.title ===
        MOVIE_LANDING_PAGE_RAILS.MOVIES_BROWSE_BY_LANGUAGE ||
      trayDetails.title === MOVIE_LANDING_PAGE_RAILS.MOVIES_BROWSE_BY_GENRE
    ) {
      railElements = Array.from(trayData.content)
        .map((s) => s.value)
        .join(',');
    }
    let isRecomended;

    mixpanelObject[MIXPANEL_TAB_NAME] =
      (trayDetails && trayDetails.tabName) ||
      (pageName &&
        (pageName.includes('landing') ||
        pageName.includes(NavMenuElements.HOME) ||
        pageName.includes(NavMenuElements.PREMIUM) ||
        pageName.includes(NavMenuElements.LIVE)
          ? pageName
          : MIXPANEL_DEFAULT_VALUES.NOT_AVAILABLE));
    mixpanelObject[MIXPANEL_CAROUSAL_NAME] = trayDetails?.carouselTitle;
    mixpanelObject[MIXPANEL_CAROUSAL_ID] =
      trayDetails?.assestDetails?.contentId;
    mixpanelObject[MIXPANEL_RAIL_CONTENT_LISTING] = railElements;
    mixpanelObject[MIXPANEL_TALAMOOS_VERTICAL_INDEX] =
      trayDetails.isRecommendedColumn &&
      deviceWidth > DEVICE_WIDTH_CONSTANTS.deviceWidth1200
        ? MIXPANEL_DEFAULT_VALUES.NOT_AVAILABLE
        : trayDetails.index;
    if (trayDetails.type === MixpanelRailTypes.RECO) {
      isRecomended = true;
      mixpanelObject[MIXPANEL_MODEL_NAME] =
        trayDetails.talamoosModelName || MIXPANEL_DEFAULT_VALUES.NOT_AVAILABLE;
      mixpanelObject[MIXPANEL_MODEL_ORIGIN] = `${pageName}_${
        trayDetails.title || trayDetails?.assestDetails?.originalTitle
      }`;
    } else {
      isRecomended = false;
      mixpanelObject[MIXPANEL_MODEL_NAME] =
        MIXPANEL_DEFAULT_VALUES.NOT_AVAILABLE;
      mixpanelObject[MIXPANEL_MODEL_ORIGIN] =
        MIXPANEL_DEFAULT_VALUES.NOT_AVAILABLE;
    }
    mixpanelObject[MIXPANEL_IS_RECOMMENDED] = isRecomended;
    const contentPartnerDetails = trayData.partnerDetails;
    if (contentPartnerDetails && Object.keys(contentPartnerDetails)?.length) {
      const {
        content_partner_name: partnerName = '',
        content_partner_id: partnerId = ''
      } = contentPartnerDetails || {};
      const isUserSubscribedToPartner = isUserSubscribedToPartnerCheck({
        subscriptions: currentActiveSubscriptions,
        contentPartnerDetails
      });
      const activePartnerSubscriptions =
        getActivePartnerSubscriptions() ||
        MIXPANEL_DEFAULT_VALUES.NOT_AVAILABLE;
      const contentOwner =
        getContentOwner(contentPartnerDetails) ||
        MIXPANEL_DEFAULT_VALUES.NOT_AVAILABLE;
      mixpanelObject[MIXPANEL_AGGREGATOR_PARTNER_NAME] =
        partnerName || MIXPANEL_DEFAULT_VALUES.NOT_AVAILABLE;
      mixpanelObject[MIXPANEL_AGGREGATOR_PARTNER_ID] =
        partnerId || MIXPANEL_DEFAULT_VALUES.NOT_AVAILABLE;
      mixpanelObject[MIXPANEL_CONTENT_OWNER] = contentOwner;
      mixpanelObject[MIXPANEL_IS_RECOMMENDED] =
        isRecomended || MIXPANEL_DEFAULT_VALUES.NOT_AVAILABLE;
      mixpanelObject[MIXPANEL_AGGREGATOR_USER_TYPE] = isUserSubscribedToPartner
        ? MIXPANEL_SUBSCRIBED
        : MIXPANEL_NOT_SUBSCRIBED;
      mixpanelObject[MIXPANEL_ACTIVE_PARTNER_SUBSCRIPTION] =
        activePartnerSubscriptions;
    }
    if (isSearchLanding) {
      if (railsMixpanelPayload?.railIDs && railsMixpanelPayload?.railElements) {
        mixpanelObject[MIXPANEL_RAIL_CONTENT_LISTING_ID] =
          railsMixpanelPayload?.railIDs.split(',');
        mixpanelObject[MIXPANEL_RAIL_CONTENT_LISTING] =
          railsMixpanelPayload?.railElements.split(',');
      }
      mixpanelObject[MIXPANEL_PAGE_NAME] = MIXPANEL_SEARCH_LANDING;
      mixpanelObject[MIXPANEL_CONTENT_COUNT] =
        railsMixpanelPayload?.trayData?.content?.length;
      mixpanelObject[MIXPANEL_CAROUSAL_NAME] =
        railsMixpanelPayload.trayDetails.carouselTitle;
      mixpanelObject[
        MIXPANEL_CAROUSAL_SLOT_ID
      ] = `${MIXPANEL_SEARCH_LANDING}_${railsMixpanelPayload?.trayDetails?.index}`;
      mixpanelObject[MIXPANEL_VERTICAL_INDEX] =
        railsMixpanelPayload.trayDetails.index;
    }
    pageRailImpression(isSearchLanding);
  }
};

export const clearRentalMixpanelData = (mixpanelObject: any) => {
  mixpanelObject.setProperty(MIXPANEL_TAB_NAME, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_CAROUSAL_NAME, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_CAROUSAL_ID, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_COST, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_IS_RENTAL, false);
  mixpanelObject.setProperty(MIXPANEL_RENTAL_RELEASE_DATE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_RENTAL_PURCHASE_DATE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_RENTAL_PURCHASE_EXPIRY_DATE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_ACTUAL_COST, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_CONTENT_ID, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_CONTENT_TYPE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_CONTENT_BILLING_TYPE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_GENRE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_CHARACTERS, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_CONTENT_DURATION, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_PUBLISHING_DATE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_SERIES, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_EPISODE_NO, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_TOP_CATEGORY, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_CONTENT_SPECIFICATION, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_CHANNEL_NAME, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_SUBTITLES, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_CONTENT_ORIGIAL_LANGUAGE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_AUDIO_LANGUAGE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_SUBTITLE_LANGUAGE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_CONTENT_NAME, 'N/A');
};

export const mixpanelPropertySetterForPlex = () => {
  mixpanelObject.setProperty(MIXPANEL_POP_UP_NAME, MIXPANEL_LEARN_MORE_PLEX);
  mixpanelObject.setProperty(MIXPANEL_POP_UP_TYPE, MIXPANEL_NATIVE);
  mixpanelObject.setProperty(MIXPANEL_POP_UP_GROUP, MIXPANEL_RENTAL);
};

export const triggerLearnMorePopUpMixpanelEvent = (
  triggerLearnMorePopUp: boolean,
  element: string
) => {
  if (!triggerLearnMorePopUp) {
    mixpanelObject.setProperty(
      MIXPANEL_TAB_NAME,
      getPageName(window.location.pathname)
    );
    mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_CTA);
    mixpanelObject.setProperty(MIXPANEL_ELEMENT, element);
    ctaEvent();
    mixpanelPropertySetterForPlex();
    popupLaunchEvent();
  } else {
    mixpanelPropertySetterForPlex();
    mixpanelObject.setProperty(MIXPANEL_ELEMENT, element);
    mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_CTA);
    mixpanelObject.setProperty(
      MIXPANEL_TAB_NAME,
      getPageName(window.location.pathname)
    );
    popupCTAEvent();
  }
};
